import React from "react";

import BotaoVoltar from "./components/BotaoVoltar";
import LogUtil from "./util/LogUtil";
import Carregando from "./components/Carregando";
import Rodape from "./components/Rodape";

import { ReactComponent as LogoBemQuerer } from "./assets/images/img_logo_bem_querer.svg";

type AjudaPagBQProps = {
};

type AjudaPagBQState = {
  carregando: boolean;
  concluido: boolean;
};

class AjudaPagBQ extends React.Component<AjudaPagBQProps, AjudaPagBQState> {

  constructor(props: AjudaPagBQProps) {
    super(props);

    this.state = {
      carregando: false,
      concluido: true,
    };
  }

  componentDidMount(): void {
    LogUtil.logPage("Menu / Cliente Bem Querer");
  }

  render(): any {
    const { carregando, concluido } = this.state;

    return (
      <section className="help">
        <div className="header">
          <BotaoVoltar titulo="Cliente Bem Querer"></BotaoVoltar>
        </div>
        <div className="content">
          <LogoBemQuerer />
          <p>
            Com o novo programa de benefícios Cliente Bem Querer, todos os consumidores inscritos
            poderão usufruir de valores ainda mais atrativos em ofertas que estarão em nossos
            tabloides, Preço Verde e Minha Hora Oba, toda semana.
          </p>
          <p>
            A qualidade e variedade de produtos que você só encontra
            no Oba, por um melhor custo-benefício.
          </p>
        </div>
        <Rodape parent={this} ativo="Menu"></Rodape>
        <Carregando exibir={ carregando } concluido={concluido} />
      </section>
    );
  }
}

export default AjudaPagBQ;
